import { t } from '~/i18n';
import routes from './routes';
import { MenuRoute } from '@watcherr/ui';
import { ProfileType } from '@watcherr/resources';
const menu: MenuRoute[] = [
  {
    label: t('menu.dashboard.dashboard'),
    icon: 'dashboard',
    route: routes.dashboard,
  },
  {
    label: t('menu.dashboard.alerts'),
    icon: 'alarm',
    route: routes.alerts,
    profileType: [ProfileType.HealthcareProvider, ProfileType.WatcherrEmployee],
  },
  {
    label: t('menu.dashboard.residents'),
    icon: 'user',
    route: routes.residents,
    profileType: [ProfileType.HealthcareProvider, ProfileType.WatcherrEmployee],
  },
  {
    label: t('menu.dashboard.healthcareProviders'),
    icon: 'healthcare-providers',
    route: routes.healthcareProviders,
    profileType: [ProfileType.HealthcareProvider, ProfileType.WatcherrEmployee],
  },
  {
    label: t('menu.dashboard.hcpGroups'),
    icon: 'healthcare-provider-groups',
    route: routes.hcpGroups,
    profileType: [ProfileType.WatcherrEmployee], //Enable for everyone
  },
  {
    label: t('menu.dashboard.configuration'),
    icon: 'settings',
    route: routes.configuration,
    profileType: [ProfileType.HealthcareProvider, ProfileType.WatcherrEmployee],
  },
].filter((i) => !!i);

export default menu;
